import { StorageLocation } from '../types/storageLocation.ts';

interface StorageSlice {
    availableStorages: StorageLocation[]; //autocomplete for storage
    emergencies: StorageLocation[]; //autocomplete for emergency bag
    selectedStorage: StorageLocation | null;
    quantityChanged: string; //Uttag or Påfyllning (how much is taken out or put in to the storage)
    disposedQuantity: number; // Amount disposed
    storageRemaining: string; //Behållning (Remaining in storage)
    selectedEmergency: StorageLocation | null; //Akutväska
    emergencyRemaining: string; //Behållning (i akutväskan) (Remaining in emergency bag)
    setAvailableStorages: (storages: StorageLocation[]) => void;
    setEmergencies: (emergencies: StorageLocation[]) => void;
    setSelectedStorage: (storage: StorageLocation | null) => void;
    setSelectedEmergency: (emergency: StorageLocation | null) => void;
    setQuantityChanged: (value: string) => void;
    setDisposedQuantity: (value: number) => void;
    setstorageRemaining: (value: string) => void;
    setemergencyRemaining: (value: string) => void;
    resetAvailableStorage: () => void;
}

const createStorageSlice = (set: any) => ({
    availableStorages: [],
    emergencies: [],
    selectedStorage: null,
    selectedEmergency: null,
    quantityChanged: '',
    disposedQuantity: '',
    storageRemaining: '',
    emergencyRemaining: '',
    setAvailableStorages: (storages: StorageLocation[]) =>
        set({ availableStorages: storages }),
    setEmergencies: (emergencies: StorageLocation[]) =>
        set({ emergencies: emergencies }),
    setSelectedStorage: (storage: StorageLocation | null) =>
        set({ selectedStorage: storage }),
    setSelectedEmergency: (emergency: StorageLocation | null) =>
        set({ selectedEmergency: emergency }),
    setQuantityChanged: (value: string) => set({ quantityChanged: value }),
    setDisposedQuantity: (value: number) => set({ disposedQuantity: value }),
    setstorageRemaining: (value: string) => set({ storageRemaining: value }),
    setemergencyRemaining: (value: string) =>
        set({ emergencyRemaining: value }),
    resetAvailableStorage: () =>
        set({
            availableStorages: [],
            emergencies: [],
            selectedStorage: null,
            selectedEmergency: null,
            quantityChanged: '',
            disposedQuantity: '',
            storageRemaining: '',
            emergencyRemaining: '',
        }),
});

export { createStorageSlice };
export type { StorageSlice };
